import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {DownloadTicketsProps} from './interfaces'

export const DownloadTickets: React.FC<DownloadTicketsProps> = ({t, className, onClick}) => (
  <button className={className} data-hook={DH.DOWNLOAD_TICKETS} onClick={onClick}>
    {t('ticketsThankYou.downloadTickets')}
  </button>
)
